
import './Corporatelogo.css'
export default function Corporatelogo(){

    return(

            <div>

        <div className='corporatelogo'> </div>
<img src="https://corporateraastaconsulting.com/wp-content/uploads/2021/06/rishabh-logo-300x300.png" alt="" style={{position:'absolute',margin:' -30rem 2rem',width:'28rem'}}/>


<span style={{position:'absolute',fontSize:'2rem',fontWeight:'600',margin:'-5.5rem 7rem',opacity:'0.6'}}>Corporate Raasta <br/>Consulting LLP</span>



<div className='we-provide'></div>

<div  style={{
    position: "absolute",
    margin: "-4.6rem 36rem",
    fontSize: "2.2rem",
    fontWeight: "600",
    color: "teal",
  }}>Service We Provide</div>

        </div>
    )
}